export default {
    obrigatorio: v => !!v || "Campo obrigatório!",
    email: v => /.+@.+\..+/.test(v) || "E-mail não está no formato válido!",
    password: v => (v != null && v.length >= 8) || "A senha deve possuir entre 8 e 256 caracteres!",
    somente_numeros: v => /^[0-9]+$/.test(v) || "Insira somente números!",
    somente_espacos: v => (v != null && (v.trim() != '' && v.trim() != '(')) || "Informação inválida!",
    limite_campo(limit, value) {
        if (value !== null && value.toString().length <= limit) {
            return true;
        } else {
            return "Limite permitido excedido!"
        }
    },
    data: value => {
        const pattern = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/
        if (value) {
            return pattern.test(value) || "Data inválida!";
        } else {
            return true;
        }
    },
    mes: value => {
        const pattern = /^(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/
        if (value) {
            return pattern.test(value) || "Data inválida!";
        } else {
            return true;
        }
    },
};
